window.addEventListener("DOMContentLoaded", function() { 

    if(Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('article')) {
                init()
            }
        })
    }
    init()

    function init() {
        const commentsEnabled = document.querySelector('#commentsEnabled').dataset.commentsEnabled

        if(commentsEnabled == "true") {
            const toggleCommentFormBtn = document.querySelector('.commentsHeader button') 
            const hideCommentFormBtn = document.querySelector('.hideFormBtn')
            const commentForm = document.querySelector('#commentFrom')
            const commentsBody = document.querySelector('.commentsBody')
            const commentsWrap = document.querySelector('.commentsWrap')
            const greLine = document.querySelector('.greLine')
    
            toggleCommentFormBtn.addEventListener('click', showCommentForm)
            hideCommentFormBtn.addEventListener('click', showCommentForm)
    
    
            function showCommentForm() {
                commentsBody.classList.toggle('displayNone')
                commentForm.classList.toggle('displayNone')
                greLine.classList.toggle('displayNone')
                window.scrollTo({
                    top: commentsWrap.offsetTop,                
                    behavior: 'smooth'
                });
            }
    
        }
    }




});
